/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProfileEditionFunctionalError
 */
export interface ProfileEditionFunctionalError {
    /**
     * 
     * @type {string}
     * @memberof ProfileEditionFunctionalError
     */
    section: ProfileEditionFunctionalErrorSectionEnum;
    /**
     * 
     * @type {string}
     * @memberof ProfileEditionFunctionalError
     */
    errorCode: ProfileEditionFunctionalErrorErrorCodeEnum;
}


/**
 * @export
 */
export const ProfileEditionFunctionalErrorSectionEnum = {
    Header: 'HEADER',
    About: 'ABOUT',
    Unknown: 'UNKNOWN'
} as const;
export type ProfileEditionFunctionalErrorSectionEnum = typeof ProfileEditionFunctionalErrorSectionEnum[keyof typeof ProfileEditionFunctionalErrorSectionEnum];

/**
 * @export
 */
export const ProfileEditionFunctionalErrorErrorCodeEnum = {
    TooManyProfileSkills: 'TOO_MANY_PROFILE_SKILLS',
    TooManyTopSkills: 'TOO_MANY_TOP_SKILLS',
    NotEnoughTopSkills: 'NOT_ENOUGH_TOP_SKILLS',
    DailyRateTooLow: 'DAILY_RATE_TOO_LOW',
    DailyRateTooHigh: 'DAILY_RATE_TOO_HIGH',
    InvalidCurrencyCode: 'INVALID_CURRENCY_CODE',
    HeadlineTooShort: 'HEADLINE_TOO_SHORT',
    HeadlineTooLong: 'HEADLINE_TOO_LONG',
    DescriptionTooShort: 'DESCRIPTION_TOO_SHORT',
    DescriptionTooLong: 'DESCRIPTION_TOO_LONG',
    TooManyIndustryExpertises: 'TOO_MANY_INDUSTRY_EXPERTISES',
    NoEnoughLanguages: 'NO_ENOUGH_LANGUAGES',
    TooManyLanguages: 'TOO_MANY_LANGUAGES',
    TooManyAlternativeWorkplaces: 'TOO_MANY_ALTERNATIVE_WORKPLACES',
    InvalidAlternativeWorkplaces: 'INVALID_ALTERNATIVE_WORKPLACES',
    TooManyTravelLocations: 'TOO_MANY_TRAVEL_LOCATIONS',
    Unknown: 'UNKNOWN'
} as const;
export type ProfileEditionFunctionalErrorErrorCodeEnum = typeof ProfileEditionFunctionalErrorErrorCodeEnum[keyof typeof ProfileEditionFunctionalErrorErrorCodeEnum];


/**
 * Check if a given object implements the ProfileEditionFunctionalError interface.
 */
export function instanceOfProfileEditionFunctionalError(value: object): value is ProfileEditionFunctionalError {
    if (!('section' in value) || value['section'] === undefined) return false;
    if (!('errorCode' in value) || value['errorCode'] === undefined) return false;
    return true;
}

export function ProfileEditionFunctionalErrorFromJSON(json: any): ProfileEditionFunctionalError {
    return ProfileEditionFunctionalErrorFromJSONTyped(json, false);
}

export function ProfileEditionFunctionalErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProfileEditionFunctionalError {
    if (json == null) {
        return json;
    }
    return {
        
        'section': json['section'],
        'errorCode': json['errorCode'],
    };
}

export function ProfileEditionFunctionalErrorToJSON(value?: ProfileEditionFunctionalError | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'section': value['section'],
        'errorCode': value['errorCode'],
    };
}

